import { useI18n } from "@/api/i18n";
import type { FreelancerFilterFormValues } from "../utils/filterParams";
import {
  FreelancerFiltersForm,
  type FreelancerFiltersFormProps,
} from "./FreelancerFiltersForm";

export type FreelancerFiltersSidebarProps = {
  defaultValues: FreelancerFilterFormValues;
  onApply: (values: FreelancerFilterFormValues) => void;
  onReset: () => void;
  disablePriceFilter?: boolean;
  /** Forwarded to the form: hide the experience-level field (Talent Pool). */
  hideExperienceFilter?: boolean;
  /** Forwarded to the form: which page hosts the filters. */
  surface?: "search" | "pool";
  /** Forwarded to the form: accessor for the offer-subcategories hint. */
  offerContext?: FreelancerFiltersFormProps["offerContext"];
};

export function FreelancerFiltersSidebar(props: FreelancerFiltersSidebarProps) {
  const { t } = useI18n();

  return (
    <div class="h-full overflow-y-auto p-4">
      <h2 class="text-sm font-semibold text-muted-foreground uppercase tracking-widest mb-4">
        {t("company.search.freelancers.result.filters.title")}
      </h2>
      <FreelancerFiltersForm
        defaultValues={props.defaultValues}
        onSubmit={props.onApply}
        onReset={props.onReset}
        disablePriceFilter={props.disablePriceFilter}
        hideExperienceFilter={props.hideExperienceFilter}
        surface={props.surface}
        offerContext={props.offerContext}
      />
    </div>
  );
}
